import packageCover0 from './covers/package-cover-0.webp';
import packageCover1 from './covers/package-cover-1.webp';
import packageCover2 from './covers/package-cover-2.webp';
import packageCover3 from './covers/package-cover-3.webp';
import packageCover4 from './covers/package-cover-4.webp';
import packageCover5 from './covers/package-cover-5.webp';

export const streamPackageCoverSrcs = [
  packageCover0,
  packageCover1,
  packageCover2,
  packageCover3,
  packageCover4,
  packageCover5,
] as const;

const streamPackageCoverIds: readonly string[] = [
  '01K0Q5E3XNEEQ8TFPAAM0Q6HW8',
  '01JT764MBDQMH08X3FC02YE4FY',
  '01JWM6TXSHBHFRVDBH6Z1N2NV3',
  '01K7Z5XMFPPF1VA6D2WRFF113Z',
  '01JT77R44FTBD01XBNX423GWP9',
  '01JT79N32YVQ74NDYENJWVHXZY',
];

const stableCoverIndex = (packageId: string) => {
  let hash = 0;
  for (const char of packageId) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }
  return hash % streamPackageCoverSrcs.length;
};

export const streamPackageCoverSrc = (
  packageId: string,
  production = import.meta.env.MODE === 'production',
): string | undefined => {
  const index = streamPackageCoverIds.indexOf(packageId);
  if (index !== -1) return streamPackageCoverSrcs[index];
  // Non-production stacks seed mock packages that have no mapped cover.
  return production
    ? undefined
    : streamPackageCoverSrcs[stableCoverIndex(packageId)];
};
